import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Menu,
  Dropdown,
  Avatar,
  message,
  Space,
  Badge,
} from "antd";
import { Link, useNavigate, useLocation, NavLink } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import logo from "../../assets/logo.png";
import Buscador from "../Buscador/Buscador";
import BtnCarrito from "../BtnCarrito";
import BtnFavoritos from "../BtnFavoritos";
import { abrirCambioUbicacion } from "../../utils/geo/eventos";
import CampanaNotificaciones from "../Notificaciones/CampanaNotificaciones";
import MobileCartSheet from "../MobileCartSheet/MobileCartSheet";

import "./NavbarStyle.scss";
import {
  DownOutlined,
  UserOutlined,
  ShopOutlined,
  RollbackOutlined,
  DashboardOutlined,
  HomeOutlined,
  HeartOutlined,
  ShoppingCartOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import {
  fetchOrdersAndPendingMessages,
  fetchOrdersAndPendingMessagesVendedor,
} from "../../utils/ordenes/ordenesUtils";

const Navbar = () => {
  const { userData, clearUser, userFavorites, cartItems } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileCartVisible, setMobileCartVisible] = useState(false);
  // Estados para notificaciones (Badges)
  const [totalPendingMessages, setTotalPendingMessages] = useState(0);
  const [totalMessagesNav, setTotalMessagesNav] = useState(0);
  const [totalPendingMessagesVendedor, setTotalPendingMessagesVendedor] =
    useState(0);

  // --- LÓGICA DE MENSAJES Y NOTIFICACIONES ---
  useEffect(() => {
    const fetchOrdersAndMessages = async () => {
      if (userData) {
        try {
          const { totalMessages } = await fetchOrdersAndPendingMessages(
            userData.uid
          );
          setTotalPendingMessages(totalMessages);
          setTotalMessagesNav((prev) => prev + totalMessages);
        } catch (error) {
          console.error("Error fetching orders:", error);
        }
      }
    };

    const fetchOrdersAndMessagesVendedor = async () => {
      if (userData && userData.role === 1) {
        try {
          const { totalMessages } = await fetchOrdersAndPendingMessagesVendedor(
            userData.uid
          );
          setTotalPendingMessagesVendedor(totalMessages);
          setTotalMessagesNav((prev) => prev + totalMessages);
        } catch (error) {
          console.error("Error fetching vendor orders:", error);
        }
      }
    };

    fetchOrdersAndMessages();
    fetchOrdersAndMessagesVendedor();
  }, [userData]);

  const handleLogout = () => {
    Modal.confirm({
      title: "Cerrar sesión",
      content: "¿Estás seguro de que deseas cerrar sesión?",
      okText: "Sí",
      okType: "danger",
      cancelText: "Cancelar",
      onOk: async () => {
        try {
          clearUser();
          message.success("Sesión cerrada exitosamente");
          navigate("/login");
        } catch (error) {
          message.error("Error al cerrar la sesión");
        }
      },
    });
  };

  // --- MENÚ DESPLEGABLE DE ESCRITORIO (PC) ---
  const menuDesktop = (
    <Menu className="custom-dropdown-menu">
      <Menu.Item key="1" icon={<UserOutlined />}>
        <Link to="/perfil">
          Mi Perfil
          {totalPendingMessages > 0 && (
            <Badge count={totalPendingMessages} style={{ marginLeft: 8 }} />
          )}
        </Link>
      </Menu.Item>

      {userData && userData.role === 1 && (
        <Menu.Item key="vendor" icon={<ShopOutlined />}>
          <Link to="/dashboard">
            Panel Vendedor
            {totalPendingMessagesVendedor > 0 && (
              <Badge
                count={totalPendingMessagesVendedor}
                style={{ marginLeft: 8 }}
              />
            )}
          </Link>
        </Menu.Item>
      )}

      {userData && userData.role === 2 && (
        <Menu.Item key="admin" icon={<DashboardOutlined />}>
          <Link to="/admin">Panel Administrador</Link>
        </Menu.Item>
      )}

      <Menu.Divider />

      <Menu.Item
        key="logout"
        onClick={handleLogout}
        icon={<RollbackOutlined />}
        danger
      >
        Cerrar sesión
      </Menu.Item>
    </Menu>
  );
  // --- Función que te faltaba ---
  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  
  return (
    <>
      {/* --- BARRA SUPERIOR --- */}
      <nav className="styled-navbar">
        {/* 1. LOGO - Se oculta en móvil para dar espacio al buscador */}
        <Link to="/" className="logo-container hide-on-mobile">
          <img src={logo} alt="Blizu" className="logo-img" />
        </Link>

        {/* 2. BUSCADOR - En móvil ocupará todo el ancho disponible */}
        <div className="search-wrapper">
          <Buscador />
        </div>

        {/* 3. ACCIONES DE ESCRITORIO (Se ocultan en móvil vía CSS) */}
        <div className="desktop-actions">
          {userData ? (
            <Space size={16}>
              {/* Dropdown Usuario */}
              <Dropdown
                dropdownRender={() => menuDesktop}
                trigger={["click"]}
                placement="bottomRight"
              >
                <div className="user-pill">
                  <Avatar
                    src={userData.photo}
                    icon={!userData.photo && <UserOutlined />}
                    size="small"
                  />
                  <span className="pill-username">
                    {userData.username?.split(" ")[0]}
                  </span>
                  {totalMessagesNav > 0 && (
                    <Badge dot status="error" offset={[-2, 0]} />
                  )}
                  <DownOutlined style={{ fontSize: 10, color: "#aaa" }} />
                </div>
              </Dropdown>

              <Button type="text" icon={<EnvironmentOutlined />} onClick={abrirCambioUbicacion} title="Cambiar mi ubicación" />

              <BtnFavoritos
                favoriteItems={userFavorites}
                disabled={false}
                text={false}
              />
              <BtnCarrito cartItems={cartItems} disabled={false} text={false} />
              <CampanaNotificaciones />
            </Space>
          ) : (
            <Space className="auth-buttons">
              <Link to="/login">
                <Button type="primary" className="btn-login">
                  Iniciar sesión
                </Button>
              </Link>
              <Link to="/tipo">
                <Button type="text">Registrarse</Button>
              </Link>
            </Space>
          )}
        </div>
      </nav>

<nav className="bottom-navbar">
        <NavLink 
          to="/" 
          end 
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
        >
          <div className="nav-content">
            <HomeOutlined className="icon" />
            <span>Inicio</span>
          </div>
        </NavLink>

        <NavLink 
          to="/favoritos" 
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
        >
          <div className="nav-content">
            {/* 🔥 BADGE DE FAVORITOS CORREGIDO */}
            <Badge 
              // Sumamos productos + servicios. Usamos || 0 por si alguno es undefined
              count={(userFavorites?.productos?.length || 0) + (userFavorites?.servicios?.length || 0)} 
              size="small" 
              offset={[5, 0]} 
              showZero={false} 
            >
              <HeartOutlined className="icon" />
            </Badge>
            <span>Favoritos</span>
          </div>
        </NavLink>

        <NavLink
          to="/carrito"
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          onClick={(e) => {
            // Si hay items en el carrito, abrir el sheet en móvil
            const hasItems = (cartItems?.productos?.length || 0) + (cartItems?.servicios?.length || 0) > 0;
            if (hasItems && window.innerWidth <= 850) {
              e.preventDefault();
              setMobileCartVisible(true);
            }
          }}
        >
          <div className="nav-content">
             {/* 🔥 BADGE DE CARRITO CORREGIDO */}
            <Badge 
              // Misma lógica: suma de ambas listas
              count={(cartItems?.productos?.length || 0) + (cartItems?.servicios?.length || 0)} 
              size="small" 
              offset={[5, 0]} 
              showZero={false}
            >
              <ShoppingCartOutlined className="icon" />
            </Badge>
            <span>Carrito</span>
          </div>
        </NavLink>

        <NavLink 
          to={userData ? "/perfil" : "/login"} 
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
        >
          <div className="nav-content">
            {/* Badge de perfil (Este se queda igual, usa tu lógica de mensajes) */}
            <Badge dot={totalMessagesNav > 0} offset={[3, 3]}>
              <UserOutlined className="icon" />
            </Badge>
            <span>{userData ? "Perfil" : "Iniciar sesión"}</span>
          </div>
        </NavLink>
      </nav>

      {/* Mobile Cart Sheet - Solo visible en móvil */}
      <MobileCartSheet
        visible={mobileCartVisible}
        onClose={() => setMobileCartVisible(false)}
        cartItems={cartItems}
      />
    </>
  );
};

export default Navbar;
